import AjaxFormModal from './AjaxFormModal';
import CampingAjaxForm from '../forms/CampingAjaxForm';

class LoginModal extends AjaxFormModal {
  constructor(loginUrl) {
    super(loginUrl, CampingAjaxForm, { form_fields_container_selector: '#responseContainer' });
  }

  setModalStyle() {
    this.elements.modal_window.classList.add('login-modal-temp');
  }

  unsetModalStyle() {
    this.elements.modal_window.classList.remove('login-modal-temp');
  }
}

export default LoginModal;



// WEBPACK FOOTER //
// ./src/js/modals/LoginModal.js